import React from 'react';
import teamImage from '../../../assets/images/about/empowering-ghanaians.webp';

export default function Hero() {
  return (
    <div className="relative min-h-screen overflow-hidden pt-28 bg-gradient-to-br from-purple-900 via-purple-800 to-orange-500/30">
      {/* Content */}
      <div className="relative px-6 mx-auto text-center max-w-7xl">
        <div className="max-w-5xl mx-auto space-y-8">
          <h1 className="space-y-4">
            <span className="block text-4xl font-normal text-white sm:text-5xl lg:text-5xl">
              <span className="font-normal text-white">Sim</span>
              <span className="font-normal text-orange-400">Finance</span>
              <span className="text-white"> -Empowering Ghanaians</span>
            </span>
            <span className="block text-3xl font-normal text-white sm:text-4xl lg:text-5xl">
              Through Financial Clarity
            </span>
          </h1>
          
          <p className="max-w-3xl mx-auto text-base leading-relaxed text-gray-200 sm:text-lg lg:text-xl">
            At SimFinance, we believe informed choices create better futures. By
            removing financial guesswork, we equip you with clear, trustworthy
            information to confidently compare, plan, and achieve your financial goals.
          </p>
        </div>

        {/* Team Image */}
        <div className="max-w-4xl mx-auto mt-8">
          <img
            src={teamImage}
            alt="SimFinance Team"
            className="w-full rounded-lg shadow-xl"
          />
        </div>
      </div>
    </div>
  );
} 